import { multiAreaCascadeConstants } from "./../constants"

const initialState = { 
  loading: false,
  fields: [],
}

export const multiAreaCascade = (state = initialState, action) => {
  switch(action.type) {
    case multiAreaCascadeConstants.MULTI_AREA_CASCADE_INITIAL: {
      const filteredLocals = [...new Set(action.payload.locals.map((item) => item).map(o => JSON.stringify(o)))].map(s => JSON.parse(s));
      let localOptions = [];
      let occupationAreaOptions = []
      let hasOneBUL = false;
      let businessUnitLocalsOptions = [...new Set(action.payload.locals.map((item) => { 
        return {
          label: item.businessUnit?.name,
          value: item.businessUnit?._id
        }
      }).map(o => JSON.stringify(o)))].map(s => JSON.parse(s))

      if (businessUnitLocalsOptions.length === 1) {
        const localOptionsFiltrado = action.payload.locals.filter(item => item.businessUnit?._id === businessUnitLocalsOptions[0].value)
        localOptions = [...new Set(localOptionsFiltrado.map(item => {
          return {
            label: item.local.name,
            value: item.local._id
          }
        }).map(o => JSON.stringify(o)))].map(s => JSON.parse(s))
      }

      if (localOptions.length === 1) {
        const occupationAreaFiltrado = action.payload.locals.filter(item => item.local._id === localOptions[0].value && item.businessUnit?._id === businessUnitLocalsOptions[0].value)
        occupationAreaOptions = [...new Set(occupationAreaFiltrado.map(item => {
          return {
            label: item.occupationArea.name,
            value: item.occupationArea._id
          }
        }).map(o => JSON.stringify(o)))].map(s => JSON.parse(s))
      }

      if (businessUnitLocalsOptions.length === 1 && localOptions.length === 1 && occupationAreaOptions.length === 1) {
        hasOneBUL = true;
      }
      
      return {
        ...state,
        fields: [{
          businessUnit: {
            selectedOption: businessUnitLocalsOptions.length === 1 ? { label: businessUnitLocalsOptions[0].label, value: businessUnitLocalsOptions[0].value } : { label: "", value: "" },
            options: businessUnitLocalsOptions
          },
          local: {
            selectedOption: localOptions.length === 1 ? { label: localOptions[0].label, value: localOptions[0].value } : { label: "", value: "" }, 
            options: localOptions,
          },
          occupationArea: {
            selectedOption: occupationAreaOptions.length === 1 ? { label: occupationAreaOptions[0].label, value: occupationAreaOptions[0].value } : { label: "", value: "" },
            options: occupationAreaOptions,
          },
          selectedBusinessUnit: hasOneBUL ? filteredLocals[0] : false,
        }]
      }
    }

    case multiAreaCascadeConstants.LOAD_MULTI_AREA_CASCADE_FIELDS: {
      let businessUnitArray = [];

      return {
        ...state,
        fields: action.payload?.businessUnitLocals?.map(item => {
          businessUnitArray.push(item?._id)
          return {
            businessUnit: {
              selectedOption: { label: item.businessUnit?.name, value: item.businessUnit?._id },
              //isso aqui parece estranho mas so estou filtrando o array businessUnitArray tirando ele mesmo, 
              //porque se eu incluir o mesmo, nao vai aparecer no dropdown, mas quero filtrar os proximos, para nao aparecer o anterior
              options: [...new Set(action.payload.locals.filter(item => !businessUnitArray.filter(item => item !== item._id).includes(item._id)).map(item => ({
                label: item.businessUnit?.name,
                value: item.businessUnit?._id
              })).map(o => JSON.stringify(o)))].map(s => JSON.parse(s))
            },
            local: {
              selectedOption: { label: item.local?.name, value: item.local?._id },
              options: [...new Set(action.payload.locals.filter(businessUnitLocal => businessUnitLocal.businessUnit?._id === item.businessUnit?._id).map(item => ({
                label: item.local?.name,
                value: item.local?._id
              })).map(o => JSON.stringify(o)))].map(s => JSON.parse(s))
            },
            occupationArea: {
              selectedOption: { label: item.occupationArea.name, value: item.occupationArea._id },
              options: [...new Set(action.payload.locals.filter(
                businessUnitLocal => businessUnitLocal.businessUnit?._id === item.businessUnit?._id && businessUnitLocal.local?._id === item.local?._id).map(item => ({
                label: item.occupationArea?.name,
                value: item.occupationArea?._id
              })).map(o => JSON.stringify(o)))].map(s => JSON.parse(s))
            },
            selectedBusinessUnit: item,
          }})
      }
    }

    case multiAreaCascadeConstants.ADD_MULTI_AREA_NEW_FIELD: {
      const businessUnitArray = action.payload.locals.filter(item => !state.fields.map(field => field.selectedBusinessUnit?._id).includes(item._id));
      return {
        ...state,
        fields: [
          ...state.fields,
          {
            businessUnit: {
              selectedOption: { label: "", value: "" },
              options: [...new Set(businessUnitArray.map((item) => { 
                return {
                  label: item.businessUnit?.name,
                  value: item.businessUnit?._id
                }
              }).map(o => JSON.stringify(o)))].map(s => JSON.parse(s))
            },
            local: {
              selectedOption: { label: "", value: "" },
              options: []
            },
            occupationArea: {
              selectedOption: { label: "", value: "" },
              options:  []
            },
            selectedBusinessUnit: false,
          }
        ]
      }
    }

    case multiAreaCascadeConstants.REMOVE_MULTI_AREA_FIELD: {
      return {
        ...state,
        fields: state.fields.filter((field, index) => index !== parseInt(action.payload))
      }
    }

    case multiAreaCascadeConstants.CHANGE_MULTI_AREA_FIELD: {
      //aqui, estou filtrando por todos os imagineLocals, menos o selected (pra nao duplicar)
      //mas caso tenha apenas 1, quando chega aqui pra trocar o businessUnit ou qualquer outro subsequente,
      //ele filtra pra mostrar todas os registros, menos o selectedBusinessUnit (que é o unico), entao fica vazio os outros dropdown
      //essa funcao pode ser definitiva, ate que se prove o contrario.
      //obs: existe um map em state.fields porque o multi area cascade pode ter VARIOS selectedBusinessUnit, entao preciso montar uma array de selectedBUL
      const allSelectedBUL = state.fields.map(field => field.selectedBusinessUnit?._id);
      function localsWithoutSelectedBUL() {
        if (action.payload.locals.length === 1) {
          return action.payload.locals
        }
        return action.payload.locals.filter(item => !allSelectedBUL.includes(item._id));
      }

      const localsFilteredArray = localsWithoutSelectedBUL()

      //aqui, vou montar uma array de fields para cada campo, baseado na escolha do campo anterior, 
      //filtrando e eliminando os repetidos. No ultimo step, vou procurar um objeto de businessUnitLocals que de match com tudo
      //e trazer apenas ele para o selectedBusinessUnit
      switch(action.payload.unit) {
        case "businessUnit":
          const localOptions = localsFilteredArray.filter(item => action.payload.value === item.businessUnit?._id)
          state = {
            ...state,
            fields: state.fields.map((item, index) => {
              if (index === action.payload.fieldIndex) {
                return {
                  ...item,
                  local: {
                    selectedOption: { label: "", value: "" },
                    options: [...new Set(localOptions.map((item) => { 
                      return {
                        label: item.local.name,
                        value: item.local._id
                      }
                    }).map(o => JSON.stringify(o)))].map(s => JSON.parse(s))
                  },
                  occupationArea: {
                    options: [],
                    selectedOption: { label: "", value: "" },
                  },
                  selectedBusinessUnit: false,
                }
              }
              return item;
            })
          }
          break;

        case "local":
          const occupationOptions = localsFilteredArray.filter(
            item => 
            (item.local._id === action.payload.value) && 
            (item.businessUnit?._id === state.fields[action.payload.fieldIndex].businessUnit?.selectedOption.value)
          )
          state = {
            ...state,
            fields: state.fields.map((item, index) => {
              if (index === action.payload.fieldIndex) {
                return {
                  ...item,
                  occupationArea: {
                    selectedOption: { label: "", value: "" },
                    options: [...new Set(occupationOptions.map((item) => { 
                      return {
                        label: item.occupationArea.name,
                        value: item.occupationArea._id
                      }
                    }).map(o => JSON.stringify(o)))].map(s => JSON.parse(s))
                  },
                  selectedBusinessUnit: false,
                }
              }
              return item;
            })
          }
          break

        case "occupationArea":
          let selectedBusiness = action.payload.locals.filter(item => {
              const fields = state.fields;
              const businessUnit = item.businessUnit?._id === fields[action.payload.fieldIndex].businessUnit?.selectedOption.value;
              const local = item.local._id === fields[action.payload.fieldIndex].local.selectedOption.value;
              const occupationArea = item.occupationArea._id ===  action.payload.value;
              return businessUnit && occupationArea && local
            } 
          )[0]

          state = {
            ...state,
            fields: state.fields.map((field, index) => {
              if (index === action.payload.fieldIndex) {
                return {
                  ...field,
                  selectedBusinessUnit: selectedBusiness
                }
              }
              return field
            })
          }
          break
        
        default: {
          state = { ...state };
          break;
        }
      }

      return { 
        ...state,
        fields: state.fields.map((field, index) => {
          if (index === action.payload.fieldIndex) {
            return  {
              ...field,
              [action.payload.unit]: {
                ...field[action.payload.unit],
                selectedOption: { 
                  value: action.payload.value,
                  label: action.payload.label
                }
              }
            }
          }

          return field
        })
      }
    }

    case multiAreaCascadeConstants.CLEAR_ALL_MULTI_AREA: {
      return initialState;
    }

    default:
      return state;
  }
}